// SLIDER D'UPSELL (panier / mini-cart) : initialise Flickity sur le carrousel de suggestions
function initCartUpsellCarousels() {
  document.querySelectorAll('.cart-upsell-container .product-list').forEach(function (productList) {
    if (productList.cartUpsellFlickity) {
      productList.cartUpsellFlickity.destroy();
      productList.cartUpsellFlickity = null;
    }

    if (!window.Flickity || !productList.querySelector('.product-item')) {
      return;
    }

    productList.cartUpsellFlickity = new window.Flickity(productList, {
      watchCSS: false, // Changed from true to force initialization
      pageDots: false,
      prevNextButtons: true,
      contain: true,
      groupCells: false,
      cellAlign: 'left',
    });
  });
}

// Ensure events re-trigger properly
document.addEventListener('DOMContentLoaded', initCartUpsellCarousels);
document.addEventListener('cart:refresh', initCartUpsellCarousels);
document.addEventListener('cart:rerendered', initCartUpsellCarousels);
document.documentElement.addEventListener('cart:refresh', function() {
  setTimeout(initCartUpsellCarousels, 100);
});